import * as React from "react";
import { PureComponent } from "react";
import { IsMobileDevice } from "source/app/domain/Device/Helpers/IsMobile";
import MusicMenu from "source/app/presentation/Header/Tools/Sound/Music/MusicMenu";
import {
    GAMEStation,
    NextRadioStationAsync,
    PreviousRadioStationAsync,
} from "source/app/services/Sound/Radio/RadioStations";
import SoundManager from "source/app/services/Sound/SoundManager";
import { ToggleGarbleAnimation } from "source/app/services/UI/Garble/Garble";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import PlayerMenu from "./PlayerMenu";
import DeepWorkKipsToday from "./DeepWorkKipsToday/DeepWorkKipsToday";
import Diversity from "./Diversity/Diversity";
import { RadioName } from "./RadioName";
import AmbienceMenu from "./Sound/Ambience/AmbienceMenu";
import Tool from "./Tool";
import { ToolItemWithBorder } from "./ToolItemWithBorder";
import { IToolsState } from "./ToolsState";
import Music from "source/app/services/Sound/Music/Music";
import Ambience from "source/app/services/Sound/Ambience/Ambience";
import { LevelAnalyzer } from "source/app/presentation/Header/Tools/Sound/LevelAnalyzer";
import SoundMasterMenu from "source/app/presentation/Header/Tools/Sound/Master/SoundMasterMenu";

export default class Tools extends PureComponent<IToolsProps, IToolsState> {
    constructor(props: IToolsProps) {
        super(props);

        this.state = {
            timeLeft: 0,
            timerHowl: undefined,
            radioStationURL: GAMEStation.url,
            radioName: "",
            radioVolume: 1,
            radioHowl: undefined,
            environmentStreams: [],
            garbleEnabled: false,
            garbleHowl: undefined,
            enableAnimations: false,
            isMobile: IsMobileDevice(),
            isMuted: false,
            isMusicPlaying: false,
            isStopped: false,
            SetIsMuted: (isMuted: boolean) => this.setState({ isMuted }),
        };
    }

    componentDidMount() {
        State.ShareClass(ESharedComponent.Tools, this);
    }

    componentDidUpdate() {
        State.ShareClass(ESharedComponent.Tools, this);
    }

    render() {
        const { isMusicPlaying } = this.state;

        return (
            <span
                id="pnlTools"
                className="statisticsContainer pnlTitleItem"
                style={{ float: "right" }}
            >
                <DeepWorkKipsToday />
                <Diversity diversityTarget={this.props.diversityTarget} />
                <Tool
                    options={{
                        onClick: ToggleGarbleAnimation,
                        classes:
                            "glyphicon-jpy " +
                            (this.state.garbleEnabled ? "orange flash" : ""),
                    }}
                />
                <Tool
                    options={{
                        onClick: SoundManager.ToggleMute,
                        classes:
                            "glyphicon-volume-off " +
                            (this.state.isMuted ? "orange" : ""),
                    }}
                />
                <ToolItemWithBorder $shouldShow={!IsMobileDevice()}>
                    <SoundMasterMenu />
                </ToolItemWithBorder>
                <ToolItemWithBorder $shouldShow={!IsMobileDevice()}>
                    <AmbienceMenu />
                </ToolItemWithBorder>
                <ToolItemWithBorder $shouldShow={!IsMobileDevice()}>
                    <MusicMenu />
                </ToolItemWithBorder>
                <PlayerMenu />
            </span>
        );
    }
}

interface IToolsProps {
    diversityTarget: number;
}
